// extracted by mini-css-extract-plugin
export default {"linkIndicatorRightOffset":"28px","linkIndicatorWidth":"20px"};